import React from 'react';
import {useTranslation} from "react-i18next";
import Dialog from "../../../../../components/ui/Dialog/Dialog";
import ProposeRate from "./ProposeRate";

type ProposeRateDialogProps = {
    id: string;
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProposeRateDialog: React.FC<ProposeRateDialogProps> = ({
                                                                 id,
                                                                 show,
                                                                 setShow
                                                             }) => {
    const {t} = useTranslation();

    return (
        <Dialog id={'propose-bet-offer-dialog'}
                show={show}
                setShow={setShow}
                width={'650px'}
                title={t("shared.btn.propose-rate")}>
            <ProposeRate id={id}
                         close={() => setShow(prev => !prev)}/>
        </Dialog>
    );
};

export default ProposeRateDialog;